// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

var PublicSuffixList = require('psl');
var domainObject = PublicSuffixList.parse(document.domain);
// {
//     "input": "www.vilarica.io",
//     "tld": "io",
//     "sld": "iporto",
//     "domain": "vilarica.io",
//     "subdomain": "www",
//     "listed": true
// }

export const environment = {
  production: true,
  app_name: 'Vila Rica',

  // Dev
  web_url: 'https://vilarica.com.br',
  app_url: 'https://app.vilarica.com.br',
  api_url: 'https://api-delivery-center.vilarica.com.br/api/',
  api_doc: 'https://api-delivery-center.vilarica.com.br/docs',
  api_url_auth: 'https://api-delivery-center.vilarica.com.br/api/',
  api_url_account: 'https://api-delivery-center.vilarica.com.br/api/',

  http_garbage_collection: null,

  page: {
    url: document.URL,
    domain: document.domain,
    expression: document.location.pathname,
  },
};
